import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  selectBuyNowAlternativePaymentsError,
  selectBuyNowAlternativePaymentsLoading,
  selectBuyNowAlternativePaymentsRetryCount,
  selectBuyNowAlternativePaymentsStatusCode
} from '@/Application/Selectors/buyNow/useBuyNowAlternativePayments';
import {
  selectBuyNowCartError,
  selectBuyNowCartLoading,
  selectBuyNowCartRetryCount,
  selectBuyNowCartStatusCode
} from '@/Application/Selectors/buyNow/useBuyNowCart';
import {
  selectBuyNowShippingGroupingError,
  selectBuyNowShippingGroupingLoading,
  selectBuyNowShippingGroupingRetryCount,
  selectBuyNowShippingGroupingStatusCode
} from '@/sections/shippingMethods/hooks/useBuyNowShippingGrouping';

const useBuyNowErrorBoundary = () => {
  const cartError = useAppSelector(selectBuyNowCartError);
  const cartLoading = useAppSelector(selectBuyNowCartLoading);
  const cartStatusCode = useAppSelector(selectBuyNowCartStatusCode);
  const cartRetryCount = useAppSelector(selectBuyNowCartRetryCount);

  const alternativePaymentsError = useAppSelector(
    selectBuyNowAlternativePaymentsError
  );
  const alternativePaymentsLoading = useAppSelector(
    selectBuyNowAlternativePaymentsLoading
  );
  const alternativePaymentsStatusCode = useAppSelector(
    selectBuyNowAlternativePaymentsStatusCode
  );
  const alternativePaymentsRetryCount = useAppSelector(
    selectBuyNowAlternativePaymentsRetryCount
  );

  const shippingGroupingError = useAppSelector(
    selectBuyNowShippingGroupingError
  );
  const shippingGroupingLoading = useAppSelector(
    selectBuyNowShippingGroupingLoading
  );
  const shippingGroupingStatusCode = useAppSelector(
    selectBuyNowShippingGroupingStatusCode
  );
  const shippingGroupingRetryCount = useAppSelector(
    selectBuyNowShippingGroupingRetryCount
  );

  if (cartError && !cartLoading) {
    throw new Error(
      `Cart error: ${cartError} (Status: ${cartStatusCode}, Retries: ${cartRetryCount})`
    );
  }

  if (alternativePaymentsError && !alternativePaymentsLoading) {
    throw new Error(
      `Alternative payments error: ${alternativePaymentsError} (Status: ${alternativePaymentsStatusCode}, Retries: ${alternativePaymentsRetryCount})`
    );
  }

  if (shippingGroupingError && !shippingGroupingLoading) {
    throw new Error(
      `Shipping grouping error: ${shippingGroupingError} (Status: ${shippingGroupingStatusCode}, Retries: ${shippingGroupingRetryCount})`
    );
  }
};

export default useBuyNowErrorBoundary;
